import { motion } from "framer-motion";

type Props = {
  /** ジャイロの傾き角 (-90..90) */
  tilt?: number;
  /** 棒が出ているか */
  stickOut?: boolean;
  size?: number;
  label?: string;
};

/**
 * 籤箱 (六角の竹筒) — placeholder。
 * tilt に応じて回転、棒が出ると下から木製棒が覗く。
 */
export function KujiBox({ tilt = 0, stickOut, size = 160, label }: Props) {
  const clamped = Math.max(-45, Math.min(45, tilt));

  return (
    <div className="relative inline-block" aria-label={label ?? "Lottery box"}>
      <motion.div
        animate={{ rotate: clamped }}
        transition={{ type: "spring", stiffness: 180, damping: 22 }}
        style={{ width: size, height: size * 1.4, transformOrigin: "50% 90%" }}
        className="relative"
      >
        {/* 筒本体 */}
        <div
          className="absolute inset-0 rounded-[14%]"
          style={{
            background:
              "linear-gradient(135deg, #6b4c1a 0%, #8a6b2c 30%, #a07b30 50%, #6b4c1a 100%)",
            boxShadow:
              "inset -8px 0 16px rgba(0,0,0,0.4), 0 12px 24px rgba(0,0,0,0.6)",
          }}
        />
        {/* 木目 */}
        <div
          className="absolute inset-0 rounded-[14%] opacity-40 mix-blend-overlay"
          style={{
            backgroundImage:
              "repeating-linear-gradient(180deg, transparent 0 8px, rgba(0,0,0,0.15) 8px 9px)",
          }}
        />
        {/* 帯 (上下) */}
        <div
          className="absolute left-0 right-0 top-[8%] h-[8%]"
          style={{ background: "linear-gradient(to bottom, #4a2f10, #2a1a08)" }}
        />
        <div
          className="absolute left-0 right-0 bottom-[8%] h-[8%]"
          style={{ background: "linear-gradient(to bottom, #4a2f10, #2a1a08)" }}
        />
        {/* 開口部 (上面) */}
        <div
          className="absolute top-[3%] left-[12%] right-[12%] h-[6%] rounded-full"
          style={{ background: "#1a0c08", boxShadow: "inset 0 4px 6px rgba(0,0,0,0.7)" }}
        />
        {/* 棒 (出てくる) */}
        <motion.div
          aria-hidden
          initial={false}
          animate={{
            y: stickOut ? -size * 0.55 : -size * 0.05,
            opacity: stickOut ? 1 : 0.0,
          }}
          transition={{ type: "spring", stiffness: 220, damping: 18 }}
          className="absolute left-1/2 top-[6%] -translate-x-1/2"
          style={{
            width: 6,
            height: size * 0.7,
            background: "linear-gradient(to bottom, #f5deb3, #c9a55a, #8a6b2c)",
            borderRadius: 3,
            boxShadow: "0 0 8px rgba(245,222,179,0.6)",
          }}
        />
      </motion.div>
    </div>
  );
}
